import { useEffect, useState } from 'react'
import { Modal, ModalBody, ModalHeader, Spinner } from 'reactstrap'
import { database } from 'utils/firebase'
import styles from './styles.module.css'
import axios from 'axios'
import { useSelector } from 'react-redux'

const TransferChatModal = ({ isOpen, closeModal }) => {
  const me = useSelector((state) => state.app.me)

  const delegateData = useSelector((state) => state.patient.delegateData)

  const availableDoctors = [
    'SWe7jOWpdAdQxcBmRNTnTARdeRu2',
    'ZBhVxTQiM6VOPYThIr1BijTWUX23',
    '6VyzSH8QUMbOZXpmaP3850bCpFx1',
  ]
  const [doctors, setDoctors] = useState([])

  const fetchAvailableDoctors = () => {
    const promises = availableDoctors
      .filter((doctorID) => {
        return doctorID !== me.id
      })
      .map((doctorID) => {
        return database.ref(`doctors/${doctorID}`).once('value')
      })
    Promise.all(promises)
      .then((snapshots) => {
        const fetchedDoctors = snapshots
          .map((snapshot) => {
            if (snapshot.val()) {
              return {
                doctorID: snapshot.key,
                ...snapshot.val(),
              }
            }
          })
          .filter((doctor) => {
            if (doctor) return doctor
          })
        setDoctors(fetchedDoctors)
      })
      .catch((error) => {
        console.error('Error fetching doctors:', error)
      })
  }

  useEffect(() => {
    fetchAvailableDoctors()
  }, [])

  return (
    <Modal isOpen={isOpen} centered size="md">
      <ModalHeader toggle={closeModal}>
        <span>Transfer Chat</span>
      </ModalHeader>
      <ModalBody>
        <div>
          {doctors.map((doctor) => (
            <Doctor
              key={doctor.doctorID}
              name={doctor.doctorName}
              profileImageUrl={doctor.profileImageURL}
              doctorID={doctor.doctorID}
              isAssigned={delegateData?.doctorID === doctor.doctorID}
            />
          ))}

          {doctors.length === 0 && (
            <div className={styles.noDoctor}>
              <h3 className="text-muted">No doctors available to transfer!</h3>
            </div>
          )}
        </div>
      </ModalBody>
    </Modal>
  )
}

export default TransferChatModal

const Doctor = ({ name, profileImageUrl, doctorID, isAssigned }) => {
  const [isTransferring, setIsTransferring] = useState(false)
  const delegateChatID = useSelector((state) => state.patient.archiveId)

  const user = useSelector((state) => state.app.me)
  const transferChat = async () => {
    try {
      setIsTransferring(true)

      const response = await axios.post(
        `${process.env.REACT_APP_FIREBASE_CLOUD_FUNCTION_NORTH_EAST_URL}/webhook-transferDelegateChat`,
        { delegateChatID, doctorID, transferedBy: user.email },
      )
      console.log(response)
      setIsTransferring(false)
    } catch (err) {
      console.log(err)
      setIsTransferring(false)
    }
  }
  return (
    <div
      className={`${styles.doctorCard} ${
        isAssigned ? styles.assignedDoctor : ''
      }`}
    >
      <div className={styles.doctorImage}>
        <img src={profileImageUrl} alt={name} />
      </div>
      <div className={styles.doctorInfo}>
        <h3>{name}</h3>
        {isAssigned && <div className={styles.assignedBadge}>Assigned </div>}
        <button
          className={styles.transferButton}
          onClick={() => transferChat(doctorID)}
          disabled={isTransferring || isAssigned}
        >
          {isTransferring ? <Spinner /> : 'Transfer'}
        </button>
      </div>
    </div>
  )
}
